// Para birimi yardımcıları. API her fiyatı 3 para biriminde döndürür
// (priceEuro/priceTL/priceUsd ve ana sayfada minPriceEuro/minPriceTL/minPrice),
// bu yüzden dönüştürme yapmayız — sadece seçili para biriminin alanını seçeriz.

// NOT: Listeleme ekranlarında her zaman standart fiyat alanını (EUR'da priceEuro)
// gösteririz. Tahsil edilen tutar EUR'da `versionedPriceEur`'dur, ama o yalnızca
// ödeme akışında (checkout'a geçerken PlanDetail'de) kullanılır — listede değil.
export const CURRENCIES = [
  { code: 'EUR', symbol: '€', priceField: 'priceEuro', minField: 'minPriceEuro' },
  { code: 'TRY', symbol: '₺', priceField: 'priceTL', minField: 'minPriceTL' },
  { code: 'USD', symbol: '$', priceField: 'priceUsd', minField: 'minPrice' },
];

export const DEFAULT_CURRENCY = 'EUR';

export const getCurrencyMeta = (code) =>
  CURRENCIES.find((c) => c.code === code) || CURRENCIES[0];

// Sayısal değeri seçili para biriminin sembolüyle biçimler. (₺120 → ₺120,00)
export const formatPrice = (value, code) => {
  const n = parseFloat(value);
  if (value == null || Number.isNaN(n)) return null;
  const { symbol } = getCurrencyMeta(code);
  const formatted = n.toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${symbol}${formatted}`;
};

// Bir refill/obje üzerinden seçili para biriminin gösterim fiyatını alır.
export const pickPrice = (obj, code) => obj?.[getCurrencyMeta(code).priceField];

// Bir ülkenin paketleri içindeki en düşük (pozitif) fiyatı seçili para biriminde.
export const minPriceOf = (products, code) => {
  let min = null;
  (products || []).forEach((p) =>
    (p.refills || []).forEach((r) => {
      const v = parseFloat(pickPrice(r, code));
      if (!Number.isNaN(v) && v > 0) min = min == null || v < min ? v : min;
    })
  );
  return min;
};
